import React from 'react';
import './EventCard.css';

const EventCard = ({ event, compact = false, onClick }) => {
  const title = event.title || event.name || 'Event';
  const dateFormatted = event.dateFormatted || (event.eventDate
    ? new Date(event.eventDate).toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' })
    : '');
  const time = event.time || (event.startTime ? event.startTime : '');

  const handleClick = () => {
    if (onClick) {
      onClick(event);
    }
  };

  const handleActionClick = (e) => {
    e.stopPropagation();
    handleClick();
  };

  return (
    <div
      className={`event-card ${compact ? 'event-card-compact' : ''}`}
      onClick={handleClick}
      role="button"
      tabIndex={0}
      onKeyDown={(e) => e.key === 'Enter' && handleClick()}
    >
      <div className="event-card-image-wrapper">
        {event.imageUrl ? (
          <img
            src={event.imageUrl}
            alt={title}
            className="event-card-image"
            onError={(e) => {
              e.target.style.display = 'none';
            }}
          />
        ) : (
          <div className="event-card-image event-card-placeholder">
            <i className="bi bi-calendar-event"></i>
          </div>
        )}
        <div className="event-card-overlay">
          <div className="event-card-date-badge">
            <i className="bi bi-calendar-event me-1"></i>
            {dateFormatted}
          </div>
          <h4 className="event-card-title">{title}</h4>
          {!compact && time && (
            <div className="event-card-time">
              <i className="bi bi-clock me-1"></i>
              {time}
            </div>
          )}
        </div>
      </div>
      {!compact && (
        <div className="event-card-content">
          <p className="event-card-description">
            {event.shortDescription}
          </p>
          <div className="event-card-footer">
            <span className="event-card-category">
              <i className="bi bi-tag me-1"></i>
              {event.category}
            </span>
            <span className="event-card-link">
              View Event <i className="bi bi-arrow-right"></i>
            </span>
          </div>
        </div>
      )}
      {compact && (
        <div className="event-card-action">
          <button
            className="event-card-action-btn"
            onClick={handleActionClick}
          >
            <i className="bi bi-calendar-event me-1"></i>
            Book Event
          </button>
        </div>
      )}
    </div>
  );
};

export default EventCard;
